
import "bootstrap/dist/css/bootstrap.min.css";
import React, { useEffect, useRef, useState } from 'react';
import * as rsuite from 'rsuite';
import Layout from '../../Layout/InnerLayout.js';
import * as General from '../General/General.js';
import * as ReactDOM from 'react-router-dom';
import PN from 'persian-number'
import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';
import { BiFilter } from "react-icons/bi";
import AddBasketItem from "../Basket/AddBasketItem.js"
import { Helmet } from "react-helmet";


const Product = () => {

    //#region Const 
    let { Id } = ReactDOM.useParams();
    let { Group } = ReactDOM.useParams();
    let { Parent } = ReactDOM.useParams();
    let { ParentId } = ReactDOM.useParams();
    const toaster = rsuite.useToaster();
    const navigate = ReactDOM.useNavigate();
    // const AddItemRef = useRef();

    const [ProductList, setProductList] = React.useState([]);
    const [BrandIdList, setBrandIdList] = React.useState([]);
    const [GroupIdList, setGroupIdList] = React.useState([Id]);
    const [ParentIdList, setParentIdList] = React.useState([]);

    const [Price, setPrice] = React.useState([-1, -1]);
    const [BrandList, setBrandList] = React.useState([]);
    const [GroupList, setGroupList] = React.useState([]);
    const [PowerList, setPowerList] = React.useState([]);
    const [SelectPowerList, setSelectPowerList] = React.useState([]);
    const [CurrentList, setCurrentList] = React.useState([]);
    const [SelectCurrentList, setSelectCurrentList] = React.useState([]);
    const [ParentList, setParentList] = React.useState([]);
    const [MinPrice, setMinPrice] = React.useState(0);
    const [MaxPrice, SetMaxPrice] = React.useState(100000000000000000000);

    const [Title, setTitle] = React.useState("");
    const [background, setbackground] = React.useState("");
    const [PParent, setPParent] = React.useState("");
    const [PGroup, setPGrop] = React.useState("");

    const [Filteropen, setFilteropen] = React.useState(false);


    const GetProductGroup = () => {
        fetch(General.ApiRoute() + '/ProductGroup/GetByIdForWeb', {
            method: 'Get',
            headers: {
                'ApiKey': General.APIKey(),
                'Id': Id,
            },
            credentials: 'include'
        })
            .then(res => res.json())
            .then(result => {
                const img = new Image();
                document.title = result.title;
                setPParent(result.parentTitle);
                setPGrop(result.title);

                img.src = General.ApiPhotoRoute() + 'Content/Images/Product/Group/' + result.photoTag + '' + result.photoId + '_Img.jpg';
                console.dir(result.photoTag)
                if (img.complete) {
                    setbackground(General.ApiPhotoRoute() + 'Content/Images/Product/Group/' + result.photoTag + '' + result.photoId + '_Img.jpg')
                } else {
                    img.onload = () => {
                        setbackground(General.ApiPhotoRoute() + 'Content/Images/Product/Group/' + result.photoTag + '' + result.photoId + '_Img.jpg')
                    };

                    img.onerror = () => {
                        console.dir("error")

                        setbackground('')
                    };
                }
            })
    }

    const GetPowerList = () => {

        fetch(General.ApiRoute() + '/Product/GetPowerByGroup', {
            method: 'Get',
            headers: {
                'ApiKey': General.APIKey(),
                'ProductGroupId': Id
            },
            credentials: 'include'
        })
            .then(res => res.json())
            .then(result => {
                if (result.length >= 1) {

                    for (var j = 0; j < result.length; j++) {


                        if (result[j].power != 0) {
                            var Powertmp = []

                            for (var i = 0; i < result[j].productList.length; i++) {
                                Powertmp.push({
                                    Power: result[j].productList[i].power,
                                })
                            }
                            setPowerList(Powertmp)
                        }
                        if (result[j].current != 0) {
                            var Currenttmp = []
                            for (var i = 0; i < result[j].productList.length; i++) {
                                Currenttmp.push({
                                    Current: result[j].productList[i].current,
                                })
                            }
                            setCurrentList(Currenttmp)
                        }
                    }

                }

            })
    }


    const GetProductBrand = () => {
        fetch(General.ApiRoute() + '/Product/GetBrandByGroup', {
            method: 'Get',
            headers: {
                'ApiKey': General.APIKey(),
                'ProductGroupId': Id,

            },
            credentials: 'include'
        })
            .then(res => res.json())
            .then(result => {

                var tmp = []
                for (var i = 0; i < result.length; i++) {
                    tmp.push({
                        id: result[i].brandId,
                        title: result[i].brandTitle,
                        PhotoUrl: General.ApiPhotoRoute() + 'Content/Images/Product/Brand/' + result[i].brandId + '.jpg',

                    })
                }
                setBrandList(tmp)
            })
    }

    const GetProduct = () => {
        fetch(General.ApiRoute() + '/Product/SearchForWeb', {
            method: 'Get',
            headers: {
                'ApiKey': General.APIKey(),
                'WebIsActive': 1,
                'IsActive': -1,
                'ProductGroupId': GroupIdList,
                'BrandId': BrandIdList,
                'ProductGroupParentId': ParentList,
                'Title': Title,
                'BeginPrice': Price[0],
                'EndPrice': Price[1],
                'Power': SelectPowerList,
                'Current': -1

            },
            credentials: 'include'
        })
            .then(res => res.json())
            .then(result => {
                var tmp = []
                var tempMinPrice = 0;
                var tempMaxPrice = 0;
                for (var i = 0; i < result.length; i++) {
                    if (tempMinPrice >= result[i].lastPrice)
                        tempMinPrice = result[i].lastPrice;
                    if (tempMaxPrice <= result[i].lastPrice)
                        tempMaxPrice = result[i].lastPrice;

                    tmp.push({
                        Id: result[i].id,
                        Title: result[i].title,
                        BrandId: result[i].brandId,
                        SaleType: result[i].saleType,
                        LastPrice: result[i].lastPrice,
                        ParentTitle: result[i].parentTitle,
                        GroupTitle: result[i].groupTitle,
                        BrandTitle: result[i].brandTitle,
                        Comment: result[i].comment,
                        Power: result[i].power,
                        Current: result[i].current,
                        SaleCount: result[i].saleCount * 1,
                        IdentityNo: result[i].identityNo,
                        SRIID: result[i].storeRoomInventoryId,
                        photoTag: result[i].photoTag,
                        PhotoUrl: result[i].photos.length > 0 ? General.ApiPhotoRoute() + 'Content/Images/Product/Photo/' + result[i].photos[0].photoURLName : '',


                    })
                }
                console.dir(tmp)
                setProductList(tmp)
                setMinPrice(tempMinPrice);
                SetMaxPrice(tempMaxPrice);

                setPrice([tempMinPrice, tempMaxPrice])
            })
    }

    const ShowProduct = (id, title) => {
        localStorage.setItem("ProductId", id);
        localStorage.setItem("ByBrand", false);
        localStorage.setItem("BySuggestion", false);
        localStorage.setItem("ByCompare", false);

        var parent = General.toSlug(Parent, { latin: true })
        var group = General.toSlug(Group, { latin: true })
        var product = General.toSlug(title, { latin: true })
        var NewGroup = group != parent ? group.replace(parent, "").replace(/-+/g, "-").replace(/^-+|-+$/g, "") : group;
        var Newproduct = product.replace(parent, "").replace(NewGroup, "").replace(/-+/g, "-").replace(/^-+|-+$/g, "") == "" ? product :
            product.replace(parent, "").replace(NewGroup, "").replace(/-+/g, "-").replace(/^-+|-+$/g, "");
        window.location.href = '/ProductInfo/' + parent + "/" + NewGroup + "/" + Newproduct;




        // window.location.href = '/ProductInfo/' + Parent + "/" + Group + "/" + title;
        // navigate('/ProductInfo/' + Parent + "/" + Group + "/" + title)

    }

    const ChangBrand = (id, checked) => {
        var temp = [...BrandList];
        var index = temp.findIndex(x => x.id == id);
        if (index != -1) {
            temp[index].checked = checked ? 1 : 0;
        }
        if (checked && [...BrandIdList].findIndex(x => x == id) == -1) {
            setBrandIdList([...BrandIdList, id]);
        }
        else {
            var stemp = [...BrandIdList.filter(item => item !== id)];
            setBrandIdList(stemp);
        }

        setBrandList(temp);

    }

    const ChangPower = (power, checked) => {
        var temp = [...PowerList];
        var index = temp.findIndex(x => x.Power == power);
        if (index != -1) {
            temp[index].checked = checked ? 1 : 0;
        }
        if (checked && [...SelectPowerList].findIndex(x => x == power) == -1) {
            setSelectPowerList([...SelectPowerList, power]);
        }
        else {
            var stemp = [...SelectPowerList.filter(item => item !== power)];
            setSelectPowerList(stemp);
        }
        setPowerList(temp);

    }


    const ChangCurrent = (current, checked) => {
        var temp = [...CurrentList];
        var index = temp.findIndex(x => x.Current == current);
        if (index != -1) {
            temp[index].checked = checked ? 1 : 0;
        }
        if (checked && [...SelectCurrentList].findIndex(x => x == current) == -1) {
            setSelectCurrentList([...SelectCurrentList, current]);
        }
        else {
            var stemp = [...SelectCurrentList.filter(item => item !== current)];
            setSelectCurrentList(stemp);
        }
        setCurrentList(temp);

    }

    const ResetFilter = () => {
        setSelectPowerList([]);
        [...PowerList].forEach(element => {
            element.checked = 0;
        });
        setBrandIdList([]);
        [...BrandList].forEach(element => {
            element.checked = 0;
        });
        setSelectCurrentList([]);
        [...CurrentList].forEach(element => {
            element.checked = 0;
        });
        setPrice([MinPrice, MaxPrice])
    }

    //#endregion
    React.useEffect(() => {
        GetProductGroup();
        GetProductBrand();
        GetProduct();
        GetPowerList();
        localStorage.removeItem("ByBrand");
        localStorage.removeItem("ProductId");


    }, [])


    return (
        <Layout>
            <Helmet>
                <title>فروشگاه فارم آسان | تجهیزات کشاورزی و صنعتی</title>
                <meta
                    name="description"
                    content="بازرگانی فارم آسان؛ عرضه‌کننده انواع تجهیزات کشاورزی، موتور برق، پمپ، کارواش، سمپاش و ابزار صنعتی در شیراز."
                />
            </Helmet >
            <div className={isBrowser ? 'InnerBanner' : "InnerBanner_MobView"}
                style={{
                    backgroundImage: `url(${background})`
                    , background: `linear-gradient(90deg, rgba(47,72,88,1) 0%, rgba(76,114,139,1) 27%, rgba(251,250,250,1) 67%)`
                }}
            >
            </div>

            <h1 className={isBrowser ? "InnerBanner-text " : "InnerBanner-text_MobView"}>
                {PGroup}
            </h1>
            <h1 className="ProductInfoAddressBar">
                <rsuite.Row>
                    <rsuite.Col xs={16} sm={16} md={24}>
                        <rsuite.Breadcrumb>
                            <rsuite.Breadcrumb.Item href="/">
                                خانه
                            </rsuite.Breadcrumb.Item>
                            <rsuite.Breadcrumb.Item
                                href={"/Group/" + Parent + "/" + ParentId}>
                                {PParent}
                            </rsuite.Breadcrumb.Item>
                            <rsuite.Breadcrumb.Item style={{ color: '#3b6682' }}> {PGroup}</rsuite.Breadcrumb.Item>
                        </rsuite.Breadcrumb>

                    </rsuite.Col>
                    <rsuite.Col xs={8} sm={8} mdHidden lgHidden xlHidden xxlHidden className="text-start Cursor" onClick={() => setFilteropen(true)}>
                        <span className="Font13">اعمال فیلتر <BiFilter className="Font20" /></span>

                    </rsuite.Col>
                </rsuite.Row>

            </h1>
            <rsuite.Row className="p-3">
                <rsuite.Col xsHidden smHidden md={4} >

                    <rsuite.Row className=" mt-5 pt-2">
                        <rsuite.Col md={24} className="bg-light p-3 rounded ">
                            <b>قیمت</b>
                            <rsuite.RangeSlider
                                progress
                                style={{ marginTop: 16 }}
                                value={Price}
                                min={MinPrice}
                                step={1000}
                                max={MaxPrice}
                                onChange={value => {
                                    setPrice(value);
                                }}
                            />
                            <p className="mt-2 text-center">{PN.sliceNumber(Price[0].toString())} تا  {PN.sliceNumber(Price[1].toString())} ریال</p>
                        </rsuite.Col>

                        <rsuite.Col md={24} className="bg-light p-3 mt-3 rounded ">

                            <b>برند</b>
                            <br />
                            {BrandList.map((brand) =>
                                <div>
                                    <rsuite.Checkbox onChange={(e, checked) => ChangBrand(brand.id, checked)} checked={brand.checked} value={brand.checked} /> &nbsp; {brand.title}

                                </div>
                            )}

                        </rsuite.Col>
                        <rsuite.Col md={24} className={PowerList.length == 0 || (PowerList.length == 1 && PowerList[0].Power == 0) ? "hide" : " bg-light p-3 mt-3 rounded"} >
                            <b>توان</b>
                            <br />
                            {PowerList.map((power) =>
                                <div>
                                    <rsuite.Checkbox onChange={(e, checked) => ChangPower(power.Power, checked)} checked={power.checked} value={power.checked} /> &nbsp; {power.Power}
                                </div>
                            )}

                        </rsuite.Col>
                        {/* <rsuite.Col md={24} className={CurrentList.length == 0 ? "hide" : ""} >
                            <rsuite.Divider />
                            <b>جریان</b>
                            <br />
                            {CurrentList.map((current) =>
                                <div>
                                    <rsuite.Checkbox onChange={(e, checked) => ChangCurrent(current.Current, checked)} checked={current.checked} value={current.checked} /> &nbsp; {current.Current}
                                </div>
                            )}

                        </rsuite.Col> */}
                    </rsuite.Row>

                </rsuite.Col>
                <rsuite.Col xs={24} sm={24} md={20}>
                    <rsuite.Row className="justify-content-center align-items-center pt-5">

                        {ProductList.map((group) =>
                            <rsuite.Col xs={24} sm={24} md={12} lg={12}
                                className={(BrandIdList.length == 0 || BrandIdList.includes(group.BrandId)) &&
                                    (SelectPowerList.length == 0 || SelectPowerList.includes(group.Power))
                                    && (Price[0] <= group.LastPrice && Price[1] >= group.LastPrice)
                                    ? "p-2 " : "hide"}>

                                <rsuite.Card className="w-100p " shaded direction="row" >
                                    <rsuite.Row>
                                        <rsuite.Col xs={9} className="m-0 p-0">
                                            <rsuite.Image
                                                src={group.PhotoUrl}
                                                fallbackSrc="../../../../assets/images/ProductGroupPrefer.jpg"
                                                alt={group.PhotoTag}
                                                style={{ width: '100%', height: '170px' }}
                                                className="border-radius-half Cursor"
                                                onClick={() => ShowProduct(group.Id, group.Title)}
                                            />
                                        </rsuite.Col>
                                        <rsuite.Col xs={15} className="m-0 p-0" >
                                            <rsuite.Card.Header as="h5" className="Cursor Font17 text-truncate" onClick={() => ShowProduct(group.Id, group.Title)}>{group.Title}</rsuite.Card.Header>
                                            <rsuite.Card.Body className="Cursor" onClick={() => ShowProduct(group.Id, group.Title)}>
                                                <p className="Font14"><b>برند : </b> {group.BrandTitle}</p>
                                                {group.Power != 0 ?
                                                    <p className={isBrowser ? "mt-4 Font14" : "mt-2 Font13"}>
                                                        <b>توان واقعی </b> {group.Power} (کیلووات KW)
                                                    </p>
                                                    :
                                                    <></>
                                                }

                                                {group.SaleType != 3 ?
                                                    <p className="Font14 FarmAsan-text"><b>قیمت :  </b> {PN.sliceNumber(group.LastPrice)} ریال</p>
                                                    :
                                                    <p className="fw-bold FarmAsan-text ">قیمت در حال به روزرسانی </p>
                                                }
                                                {group.SaleCount > 0 && group.SaleType == 1 ?
                                                    // <p className='Font14 fw-bold text-success mt-4' > <rsuite.Image src="../../../../assets/images/weareopen.png" style={{ width: '30px', height: '30px' }} />&nbsp;<b>موجودی </b> {group.SaleCount} &nbsp;&nbsp; {group.Unit}</p>
                                                    <p className='Font14 fw-bold text-success mt-4' > <rsuite.Image src="../../../../assets/images/weareopen.png" style={{ width: '30px', height: '30px' }} />&nbsp;<b>قابل فروش </b>  </p>
                                                    : group.SaleCount == 0 && group.SaleType == 1 ?
                                                        <p className='Font14 fw-bold text-danger mt-4' > <rsuite.Image src="../../../../assets/images/soldoutstamp.png" style={{ width: '30px', height: '30px' }} />&nbsp;&nbsp;<b> اتمام موجودی </b></p>
                                                        : group.SaleType == 2 ?
                                                            <p className='Font14 fw-bold text-info mt-4' > <rsuite.Image src="../../../../assets/images/reservation.jpg" style={{ width: '30px', height: '30px' }} />&nbsp;&nbsp;<b>قابل رزرو می باشد </b> </p>
                                                            : group.SaleType == 3 ?
                                                                <p className='Font14 fw-bold text-danger mt-4' > <rsuite.Image src="../../../../assets/images/CloseBoard.png" style={{ width: '30px', height: '30px' }} />&nbsp;&nbsp;<b> فروش بسته می باشد </b></p>
                                                                :
                                                                <></>
                                                }
                                            </rsuite.Card.Body>

                                        </rsuite.Col>
                                    </rsuite.Row>
                                    <rsuite.Row >
                                        <rsuite.Col xs={24} className="pe-3 ps-3 pb-3">
                                            <AddBasketItem className="single" value={group.Id + "|" + group.Title + "|1|" + group.SRIID + "|" + group.LastPrice + "|" + group.SaleType} disabled={(group.SaleCount > 0 && group.SaleType == 1) || group.SaleType == 2 ? false : true} />
                                        </rsuite.Col>

                                    </rsuite.Row>
                                </rsuite.Card>
                            </rsuite.Col>
                        )}
                    </rsuite.Row>

                </rsuite.Col>
            </rsuite.Row>

            <rsuite.Drawer size="xs" placement="right" open={Filteropen} onClose={() => (setFilteropen(false), ResetFilter())}>
                <rsuite.Drawer.Header>
                    <rsuite.Drawer.Title className="Font13">
                        فیلتر
                    </rsuite.Drawer.Title>
                    <rsuite.Drawer.Actions>
                        <rsuite.Button color="green" onClick={() => setFilteropen(false)} appearance="primary" block> اعمال فیلتر</rsuite.Button>
                    </rsuite.Drawer.Actions>
                </rsuite.Drawer.Header>
                <rsuite.Drawer.Body className="m-3 p-3">
                    <rsuite.Row >
                        <rsuite.Col xs={24} className="bg-light p-3 rounded ">
                            <b>قیمت</b>
                            <rsuite.RangeSlider
                                progress
                                style={{ marginTop: 16 }}
                                value={Price}
                                min={MinPrice}
                                step={1000}
                                max={MaxPrice}
                                onChange={value => {
                                    setPrice(value);
                                }}
                            />
                            <p className="mt-3 text-center">{PN.sliceNumber(Price[0].toString())} تا  {PN.sliceNumber(Price[1].toString())} ریال</p>
                        </rsuite.Col>

                        <rsuite.Col xs={24} className="bg-light p-3 mt-2 rounded ">

                            <b>برند</b>
                            <br />
                            {BrandList.map((brand) =>
                                <div>
                                    <rsuite.Checkbox onChange={(e, checked) => ChangBrand(brand.id, checked)} checked={brand.checked} value={brand.checked} /> &nbsp; {brand.title}

                                </div>
                            )}

                        </rsuite.Col>
                        <rsuite.Col xs={24} className={PowerList.length == 0 || (PowerList.length == 1 && PowerList[0].Power == 0) ? "hide" : "bg-light p-3 mt-2 rounded "} >
                            <b>توان</b>
                            <br />
                            {PowerList.map((power) =>
                                <div>
                                    <rsuite.Checkbox onChange={(e, checked) => ChangPower(power.Power, checked)} checked={power.checked} value={power.checked} /> &nbsp; {power.Power}
                                </div>
                            )}

                        </rsuite.Col>
                        {/* <rsuite.Col md={24} className={CurrentList.length == 0 ? "hide" : ""} >
                            <rsuite.Divider />
                            <b>جریان</b>
                            <br />
                            {CurrentList.map((current) =>
                                <div>
                                    <rsuite.Checkbox onChange={(e, checked) => ChangCurrent(current.Current, checked)} checked={current.checked} value={current.checked} /> &nbsp; {current.Current}
                                </div>
                            )}

                        </rsuite.Col> */}
                    </rsuite.Row>

                </rsuite.Drawer.Body>
            </rsuite.Drawer>


        </Layout >
    )
}

export default Product;